var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"self-tenant-edit"},[_c('h1',[_vm._v(_vm._s(_vm.$t('settings.editTenant')))]),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('el-skeleton',{attrs:{"rows":10,"animated":""}})],1):_c('tenant-form',{attrs:{"tenant":_vm.tenant,"mode":"edit","loading":_vm.submitLoading},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }